import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Lobby.css';
import AnimatedTitle from '../../AnimatedTitle';

const Lobby = ({
  socket, ipAddress, sessionCreated, createSession, gameStarted,
  sessionId, players, rounds, setRounds, currentRound, sessionList,
  leaderboard, removePlayer, titleTheme, AudioPlayer, isEndScene,
  speakingTheme, guessingTheme, gameMode, setGameMode, currentLine,
  isEndGame, availableImprovScripts, selectedImprovScript, setSelectedImprovScript,
  setForceRemove, forceRemove,
}) => {
  const [isExiting, setIsExiting] = useState(false);

  const modeOptions = [
    { value: 'classic', label: 'Classic (Guess Adlibber)' },
    { value: 'freeforall', label: 'Party (Everyone Guesses)' },
    { value: 'linejudge', label: 'Line Judge (Vote +/- each adlib)' },
  ];

  const handleRemovePlayer = (playerToRemove) => {
    setForceRemove(true);
    removePlayer(playerToRemove, true);
  };

  const toggleGameMode = () => {
    const currentIndex = modeOptions.findIndex((option) => option.value === gameMode);
    const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % modeOptions.length : 0;
    setGameMode(modeOptions[nextIndex].value);
  };

  const PlayerListItem = ({ player }) => {
    const [isHovered, setIsHovered] = React.useState(false);
    return (
      <li
        key={player.id}
        style={{
          textDecoration: player.removed || isHovered ? 'line-through' : 'none',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => handleRemovePlayer(player.socketId)}
      >
        {player.name}
      </li>
    );
  };

  const handleStartGame = () => {
    if (socket) {
      console.log(`Starting game with script pack: ${selectedImprovScript}`);
      setIsExiting(true);
      setTimeout(() => {
        socket.emit('startGameImprov', { sessionId, rounds, gameMode, scriptPack: selectedImprovScript });
      }, 500);
    }
  };

  const isStartGameDisabled =
    (gameMode === 'classic' && players.length !== 4) ||
    ((gameMode === 'freeforall' || gameMode === 'linejudge') && players.length < 3);

  const startGameButtonText =
    gameMode === 'classic'
      ? players.length === 4 ? "Start Game" : "Waiting for 4 players..."
      : players.length >= 3 ? "Start Game" : "Waiting for at least 3 players...";

  const modeLabel = modeOptions.find((option) => option.value === gameMode)?.label || 'Line Judge';

  return (
    <motion.div
      className="lobby-container"
      animate={{
        opacity: isExiting ? 0 : 1,
        x: isExiting ? '-100%' : '0%',
      }}
      transition={{ type: "spring", stiffness: 120, damping: 14 }} // matches config.gentle
    >
      <AnimatedTitle />
      <div className="app-container">
        <div className="players-container">
          <h4>Players:</h4>
          <ul>
            {players.map((player) => (
              <PlayerListItem key={player.id} player={player} />
            ))}
          </ul>
        </div>
        <div className="settings">
          <div>
            <h2 style={{ fontFamily: 'Alloy Ink' }}>Game Settings:</h2>
            <label>
              Number of rounds:
              <br />
              <input
                type="number"
                min="1"
                max="12"
                value={rounds}
                onChange={(e) => setRounds(parseInt(e.target.value))}
              />
            </label>
            <label>
              <br />
              Game Mode:
              <div className="button-wrapper">
                <button onClick={toggleGameMode} className="game-mode-button">
                  {modeLabel}
                </button>
              </div>
              <br />
            </label>
            <label>
              Script Pack:
              <br />
              <select
                value={selectedImprovScript}
                onChange={(e) => setSelectedImprovScript(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  marginTop: '4px',
                  borderRadius: '8px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  color: '#ffffff',
                  cursor: 'pointer',
                }}
              >
                {availableImprovScripts.map((pack) => (
                  <option key={pack} value={pack}>
                    {pack.charAt(0).toUpperCase() + pack.slice(1)}
                  </option>
                ))}
              </select>
              <br />
            </label>
          </div>
        </div>
      </div>
      <button onClick={handleStartGame} disabled={isStartGameDisabled} className="start-game">
        {startGameButtonText}
      </button>
    </motion.div>
  );
};

export default Lobby;